import styled from 'styled-components';

const Span = styled.span`
  margin-right: 4px;
  font-weight: bold;
  font-style: italic;
  padding: 2px;
  cursor: pointer;
`;

export default Span;
